export default __webpack_public_path__ + "static/media/contact-us-banner.6cf195e7.png";